const initHeroServiceImages = () => {
    const heroImages = document.querySelectorAll('.hero-services-img');
        console.log('initHeroServiceImages running');
    heroImages.forEach(img => {
        const gifUrl = img.dataset.gif;
        const gifAlt = img.dataset.gifAlt;

        if (gifUrl && gifUrl.length > 0) {
            // Preload gif
            const preloadGif = new Image();
            preloadGif.src = gifUrl;

            // Switch to gif after page load
            preloadGif.onload = () => {
                setTimeout(() => {
                    // Store original image attributes to enable switching back if needed
                    img.dataset.originalSrc = img.src;
                    img.dataset.originalAlt = img.alt;

                    // Replace with GIF
                    img.src = gifUrl;
                    if (gifAlt) img.alt = gifAlt;

                    // Add animation class
                    img.classList.add('animated');
                }, 1000);
            };
        }
    });
};

// Automatycznie uruchom funkcję po załadowaniu DOMu
document.addEventListener('DOMContentLoaded', initHeroServiceImages);

// Eksportujemy funkcję, aby była dostępna na zewnątrz
export default initHeroServiceImages;